export default __webpack_public_path__ + "static/media/otpkey.b760de86.svg";